<page-banner imageUrl="page-banner-1.png" headingText="Login"></page-banner>

<div class="content-container">

  <div class="container login-container">
    <div class="row justify-content-center" *ngIf="status=='success'">
      <div class="col-md-12">
        <div class="alert alert-success rounded-0 p-2 text-center">
          <i class="fa fa-tick fa-2x"></i>
          <span>Registration successful. Please log on below with your email and specified password.</span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center flex-column align-items-center">
      <div class="col-md-6">
        <div class="card square-edges bg-neutral-50">
          <div class="card-body" *ngIf="!stateService.userModelValid()">
            <h3>Sign in</h3>
            <p class="mt-3 font-sm" *ngIf="!isTokenLogin">Your username will be the email address used to register on the data collection system</p>
            <websilk-login id="wsLogin" (onSuccess)="loginCallback($event)" *ngIf="!isTokenLogin"></websilk-login>
            <websilk-loading *ngIf="isTokenLogin" displayText="Authenticating Token ... Please wait"></websilk-loading>
            <div *ngIf="!isTokenLogin" class="d-flex flex-column bg-light text-dark">
              <a [routerLink]="['/register']" class="btn btn-link float-left text-dark bg-neutral-25">
                <span>No Account? </span><span class="text-red">Subscribe here</span>
              </a>
            </div>
          </div>
          <div class="card-body" *ngIf="stateService.userModelValid()">
            <h2>Logged in</h2>
            <span class="d-block mt-4">You are currently logged in as <strong>{{currentUser.FirstName}} {{currentUser.Surname || currentUser.LastName}} ({{currentUser.Username}})</strong></span>
            <div class="mt-4">
              <button type="button" (click)="Logout()">Logout</button>
            </div>
          </div>
        </div>
        <div class="col-1"></div>
      </div>
    </div>
  </div>

</div>
